import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { RegisterCompleteStepChanger } from '../index'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { completeInfoConfirmSellerRolSelector, completeUserInfo, setCompleteRegisterFormValue } from 'src/features'
import { CustomCol, CustomCard, CustomTitle, CustomRadioGroup, CustomRadio } from 'src/components'
import { useRouter } from 'next/router'

type ConfirmSellType = 'IS_PRODUCER' | 'NO_PRODUCER'

const ConfirmSellerRolStep: React.FC = () => {
  const { t } = useTranslation()
  const { query: { code } } = useRouter()
  const dispatch = useAppDispatch()
  const isSellConfirmed = useAppSelector(completeInfoConfirmSellerRolSelector)

  const sellConfimValue: ConfirmSellType = isSellConfirmed ? 'IS_PRODUCER' : 'NO_PRODUCER'

  const handleChange = (value: ConfirmSellType) => {
    dispatch(setCompleteRegisterFormValue({ key: 'confirmSellerRol', value: value === 'IS_PRODUCER' }))
  }

  const onFinish = () => {
    const payload = {
      userValues: {
        is_producer: sellConfimValue === 'IS_PRODUCER',
        complete_user_info_code: code
      }
    }
    dispatch(completeUserInfo(''+code, payload))
  }

  const handleSubmitClick = () => {
    if(sellConfimValue === 'NO_PRODUCER'){
      return onFinish()
    }

    dispatch(setCompleteRegisterFormValue({ key: 'step', value: 2 }))
  }

  return (
    <div>
      <CustomCard>
        <CustomTitle label={t('Auth.CompleteInfo.Title1')} type={null} />
        <CustomTitle label={t('Auth.CompleteInfo.Subtitle1')} />
        <Row>
          <CustomCol lg={24} className='mt-5'>
            <CustomRadioGroup defaultValue={sellConfimValue} handleChange={handleChange}>
              <CustomRadio text={t('Auth.CompleteInfo.SellRol')} value={'IS_PRODUCER'} />
              <CustomRadio text={t('Auth.CompleteInfo.DenyRol')} value={'NO_PRODUCER'} />
            </CustomRadioGroup>
          </CustomCol>
        </Row>
      </CustomCard>

      <RegisterCompleteStepChanger
        nextStepValue={2}
        beforeStepValue={1}
        handleSubmitClick={handleSubmitClick}
      />
    </div>
  )
}

export default ConfirmSellerRolStep
